import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => 
{
    axios.get('lucky_spin_prize/list', {params: props})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.LIST,
            value: response.data
        })
    })
    .catch(err => 
    {
        
    });
};

export const getDropDown = () => (dispatch, getState) =>
{
    let data = {};
    data.country_id = getState().currentUser.data.country_id;
    axios.get('lucky_spin_prize/drop_down', {params: data})
    .then(function (response)
    {
        dispatch (
        {
            type: actionType.DROPDOWN,
            value: response.data
        })
    })
    .catch(err =>
    {

    });
};

export const store = (data) => dispatch =>
{
    // console.log(data);
    axios.post('lucky_spin_prize/store', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.STORE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const getDetails = (id) => (dispatch, getState) =>
{   
    if(id > 0)
    {
        axios.get('lucky_spin_prize/details',{
            params: {
                "id": id,
                "country_id": getState().currentUser.data.country_id
            }
        })
        .then(function (response) 
        {
            dispatch (
            {
                type: actionType.DETAILS,
                value: response.data
            })
        })
        .catch(function (error) 
        {
        
        });
    }
};

export const update = (data) => dispatch =>
{
    // console.log(data);
    axios.post('lucky_spin_prize/update', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const updateStatus = (data) => (dispatch, getState) =>
{
    data.country_id = getState().currentUser.data.country_id;
    axios.post('lucky_spin_prize/update_status', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE_STATUS,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};



